import Question from './question';
import TextInputTool from '../tools/text-input/text-input-tool';

export default class TextInputQuestion extends Question {
  /**
   * @property {number} answer
   */

  /**
   * @constructor
   * @param {Object}  [config]
   * @param {number}  [config.missingTermIndex] - 0, 1 or 2 corresponding to multiplicand, multiplier or product
   */
  constructor({ missingTermIndex } = {}) {
    super(...arguments);
    if ( typeof missingTermIndex === 'undefined' ) {
      missingTermIndex = Math.floor(Math.random() * 3);
    }
    this.config.missingTermIndex = missingTermIndex;
  }

  get tool() {
    return TextInputTool;
  }
  get title() {
    return 'Complete the following equation';
  }
  get result() {
    const missingTerm = [ this.multiplicand, this.multiplier, this.product ][ this.missingTermIndex ];
    return this.answer === missingTerm;
  }
  get missingTermIndex() {
    return this.config.missingTermIndex;
  }
}
